import { MediaContentType, SortByQueryOptions } from 'bpm-client-api';
import { ContentType, BPMCurated, BPMUser, BPMNews, BPMMedia, BPMAlbum, BPMCategory } from 'bpm-web-generic';
import { Album, Category, CuratedSetWithAlbum, Media, MediaWithAlbum, PlaylistWithAlbum, UserPlaylistWithAlbum, SortByQueryOptions as SBQ } from './api/download-api-sdk/src';
import { User } from './api/supreme-api-sdk/src';

export function contentTypeToAPI(contentType: ContentType): MediaContentType {
    return contentType == 'audio' ? MediaContentType.Audio : MediaContentType.Video
}

export function mapBPMPlaylist(set: PlaylistWithAlbum): BPMCurated {
    const { albums } = set
    return {
        ...set,
        curator: '',
        updated_at: set.updated_at!,
        created_at: set.created_at!,
        subtitle: set.description || '',
        is_generated: false,
        category: set.category ? { name: set.category.name, order: set.category.order! } : undefined,
        albums: (albums || []).map(apiAlbumToBPMAlbum).map((album, i) => {
            return {
                ...album,
                curated_order: i
            }
        }),
        playable: true
    }
}

export function mapUserPlaylist(set: UserPlaylistWithAlbum): BPMCurated {
    const { albums } = set
    return {
        ...set,
        created_at: new Date(set.created_at).toJSON(),
        order: 0,
        subtitle: '',
        image_url: set.image_url || 'https://av.bpmsupreme.com/covers/default_cover.png',
        image_thumbnail_url: set.image_url || 'https://av.bpmsupreme.com/covers/default_cover.png',
        is_generated: false,
        curator: 'BPM Supreme Recommendation',
        albums: (albums || []).map(apiAlbumToBPMAlbum).map((album, i) => {
            return {
                ...album,
                curated_order: i
            }
        }),
        updated_at: set.updated_at.toString(),
        playable: true
    }
}


export function mapPlaylist(set: PlaylistWithAlbum): BPMCurated {
    const { albums } = set
    return {
        ...set,
        created_at: new Date(set.created_at).toJSON(),
        order: 0,
        subtitle: set.description || '',
        image_url: set.image_url || 'https://av.bpmsupreme.com/covers/default_cover.png',
        image_thumbnail_url: set.image_url || 'https://av.bpmsupreme.com/covers/default_cover.png',
        is_generated: false,
        curator: set.artist,
        albums: (albums || []).map(apiAlbumToBPMAlbum).map((album, i) => {
            return {
                ...album,
                curated_order: i
            }
        }),
        updated_at: set.updated_at.toString(),
        playable: true
    }
}

export function mapPlaylistProvider(set: { name: string, image_url: string }, user: BPMUser): BPMCurated {
    const days = Math.floor(new Date().getTime() / 8.64e7)
    return {
        ...set,
        id: set.name,
        title: set.name,
        subtitle: '',
        order: 0,
        slug: set.name,
        image_url: set.image_url,
        image_thumbnail_url: set.image_url,
        is_generated: true,
        curator: 'BPM Supreme Recommendations',
        albums: [],
        updated_at: new Date().toJSON(),
        created_at: new Date().toJSON(),
        playable: false
    }
}

export function mapCuratedSet(set: CuratedSetWithAlbum): BPMCurated {
    const { albums } = set
    return {
        ...set,
        updated_at: set.updated_at!,
        created_at: set.created_at!,
        id: set.id,
        title: set.title,
        subtitle: set.description || '',
        curator: set.curator!,
        category: set.category ? { name: set.category.name, order: set.category.order! } : undefined,
        albums: (albums || []).map(apiAlbumToBPMAlbum).map((album, i) => {
            return {
                ...album,
                curated_order: i
            }
        }),
        playable: true,
        image_thumbnail_url: set.image_url
    }
}

export function apiCrateToBPMCrate(media: MediaWithAlbum[]) {
    return media.map(c => {
        let album = c.album!;
        album.media = [c];
        return album;
    }).map(apiAlbumToBPMAlbum)
}

export function apiCategoryToBPMCategory(category: Category): BPMCategory {
    return category
}

export function apiAlbumToBPMAlbum(album: Album): BPMAlbum {
    return {
        ...album,
        bpm: album.bpm!,
        created_at: new Date(album.created_at),
        category: apiCategoryToBPMCategory(album.category),
        image: album.cover_url,
        cover: album.cover_url,
        media: album.media.map(apiMediaToBPMMedia),
        exclusive: album.is_exclusive,
        bpm_original: album.category.name == 'BPM Originals',
        artist_info: album.artists.map((a) => a.name)
    }
}

export function apiMediaArrayToBPMMediaArray(media: Media[]): BPMMedia[] {
    let currentMedia: BPMMedia[] = []
    media.forEach((media) => {
        currentMedia.push(apiMediaToBPMMedia(media))
    })
    return currentMedia
}

export function apiMediaToBPMMedia(media: Media): BPMMedia {
    return {
        ...media,
        name: media.name,
        tag: {
            id: media.version.id,
            name: media.version.name
        },
        waves: {
            gray: media.waves.gray,
            colored: media.waves.colored
        }
    }
}

export function apiUserToBPMUser(user: User): BPMUser {
    return {
        ...user
    } as any
}

export function apiNewsToBPMNews(news: any): BPMNews {
    return {
        ...news,
        song_mapping: {}
    }
}

export function toSortBy(sort?: SortByQueryOptions): SBQ {
    if (sort == SortByQueryOptions.DateDes) {
        return SBQ.DateDesc
    }
    return sort as unknown as SBQ
}


// WEBPACK FOOTER //
// ./src/transformer.ts